(function () {
  'use strict';
  angular.module('cbl.finanza.mf.directives').directive('finDossierMovements', [
    '$filter',
    'FinDossierMovementsSrvc',
    'uiGridConstants',
    'uiGridGroupingConstants',
    'CommonUtilitiesSrvc',
    'FIN_CONSTANTS',
    function (
      $filter,
      cblDossierMovementsSrvc,
      uiGridConstants,
      uiGridGroupingConstants,
      commonUtilities,
      CONSTANTS
    ) {
      var directiveImpl = function ($scope) {
        $scope.service = cblDossierMovementsSrvc;
        $scope.commonUtilities = commonUtilities;
        $scope.spinner = $scope.commonUtilities.getSpinnerStyle($scope);

        $scope.formMovementsReset = function () {
          $scope.service.inputFormMovimenti = {
            startDate: null,
            endDate: null,
            isin: null,
            descrizione: null
          };
          $scope.service.datasource = null;
        };

        $scope.service.views.defaultView = {
          title: 'Movimenti',
          url:
            CONSTANTS.BASE_ROOT +
            'widgets/finDossierMovements/states/finDossierMovements.states.table.html',
          visible: true,
          searchEnabled: true,
          type: 'TABLE'
        };
        //$scope.detectGroupingCellContent = function (row, col) {
        //    var flag = !col.grouping || col.grouping.groupPriority === undefined || col.grouping.groupPriority === null || (row.groupHeader && col.grouping.groupPriority === row.treeLevel);
        //    return flag;
        //};
        $scope.startDateRequired = false;
        $scope.endDateRequired = false;
        // Costruzione della tabella ui-grid
        var gridColumns = [
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Numero rapporto',
            field: 'codiceDossier',
            width: '5%'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Data Contabile',
            field: 'dataContabile',
            width: '6%',
            cellFilter: 'date:"dd/MM/yyyy"'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Isin',
            field: 'isin'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Causale',
            field: 'causale'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Descrizione',
            field: 'descrizioneTitolo'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Segno',
            field: 'segnoOperazione'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: "Quantita' Nominale",
            field: 'quantitaNominale',
            cellClass: 'right',
            cellFilter: 'number: 6'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Prezzo (EUR)',
            field: 'prezzoLordo',
            cellClass: 'right',
            cellFilter: 'number: 5'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Importo (EUR)',
            field: 'totaleLiquiditaControparte',
            cellFilter: 'number: 2',
            cellClass: function (
              grid,
              row,
              col,
              rowRenderIndex,
              colRenderIndex
            ) {
              if (grid.getCellValue(row, col) < 0) return 'red right';
              return 'right';
            }
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Divisa',
            field: 'divisaTitolo'
          },
          {
            cellTooltip: true,
            headerTooltip: true,
            name: 'Cambio',
            field: 'cambio',
            cellClass: 'right',
            cellFilter: 'number: 5'
          }
        ];
        var defaultGrouping = { groupPriority: 0 };
        var defaultSort = { priority: 0, direction: 'asc' };

        var filter = $filter;

        $scope.service.gridMovimentiProdottoOptions = {
          enableSorting: true,
          enableColumnMenus: false,
          enableFiltering: true,
          enableCellEditing: false,
          enableCellEditOnFocus: false,

          enableGridMenu: true,
          gridMenuShowHideColumns: false,
          exporterCsvFilename: 'MovimentiDossier.csv',
          exporterCsvColumnSeparator: ';',
          exporterFieldCallback: function (grid, row, col, value) {
            if (col.cellFilter) {
              var filterSplit = col.cellFilter.split(':');
              var typeFilter = filterSplit[0].trim();
              var argFilter =
                filterSplit.length < 2
                  ? ''
                  : filterSplit[1].trim().replace(new RegExp(/"/g), '');
              var result = $filter(typeFilter)(value, argFilter);
              return result;
            }
            return value;
          },
          exporterHeaderFilterUseName: true,
          exporterHeaderFilter: function (name) {
            return name.toUpperCase();
          },
          exporterMenuPdf: false,

          enableColumnResizing: true,

          showGridFooter: true,
          enablePagination: true,
          paginationPageSizes: [10, 25, 50, 100],
          paginationPageSize: 10,
          paginationCurrentPage: 1,

          enableRowSelection: true,
          multiSelect: false,
          enableRowHeaderSelection: false,

          enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,

          onRegisterApi: function (gridApi) {
            $scope.service.gridApi = gridApi;

            $scope.service.gridApi.selection.on.rowSelectionChanged(
              $scope,
              function (row) {
                $scope.showDetails(row.entity);
              }
            );
          },

          columnDefs: gridColumns,
          data: $scope.service.datasource
        };
        commonUtilities.calculateHeightUIGridComponent(
          $scope.service.gridMovimentiProdottoOptions
        );

        ($scope.getDossierMovements = function () {
          this.service.searchInProgress = true;
          this.service.datasource = new Array();
          this.service.gridMovimentiProdottoOptions.data = new Array();

          var serviceUrl =
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.MOVEMENTS +
            '/' +
            $scope.numeroRapporto;
          var serviceParams = {
            dataDa: this.service.inputFormMovimenti.startDate,
            dataA: this.service.inputFormMovimenti.endDate,
            isin: this.service.inputFormMovimenti.isin,
            descrizioneTitolo: this.service.inputFormMovimenti.descrizione
          };
          if (serviceParams.dataA !== null && serviceParams.dataDa !== null) {
            serviceParams.dataDa = serviceParams.dataDa
              .toISOString()
              .substring(0, 10);
            serviceParams.dataA = serviceParams.dataA
              .toISOString()
              .substring(0, 10);
          }
          //VERIFICA SE I CAMPI CALENDARIO SONO VALORIZZATI
          $scope.startDateRequired = isNaN(
            Date.parse(this.service.inputFormMovimenti.startDate)
          );
          $scope.endDateRequired = isNaN(
            Date.parse(this.service.inputFormMovimenti.endDate)
          );
          //SE I CAMPI CALENDARIO NON SONO VALORIZZATI LA CHIAMATA NON PARTE
          if ($scope.startDateRequired || $scope.endDateRequired) {
            $scope.service.searchInProgress = false;
            return;
          }
          var parentThis = this;
          var successCallback = function (self, data) {
            if (data !== null) {
              $scope.service.datasource = data.result;

              $scope.service.gridMovimentiProdottoOptions.data =
                $scope.service.datasource;
              commonUtilities.calculateHeightUIGridComponent(
                $scope.service.gridMovimentiProdottoOptions
              );
              $scope.movementsNotFound = $scope.service.datasource.length === 0;

              $scope.service.searchInProgress = false;
            }
            $scope.internalLoading = false;
          };
          var errorCallback = function (self, error) {
            $scope.internalLoading = false;
            $scope.service.searchInProgress = false;
          };
          var showLoaderService = false;
          this.internalLoading = true;
          this.commonUtilities.executeHttpGetService(
            serviceUrl,
            serviceParams,
            parentThis,
            showLoaderService,
            successCallback,
            errorCallback
          );
        }),
          // Determina se ci sono elementi
          ($scope.hasItems = function () {
            if (
              $scope.service.datasource === null ||
              $scope.service.datasource === undefined
            ) {
              return false;
            }
            var count = $scope.service.datasource.length;
            if (count === null || count === undefined) {
              return false;
            }
            var flag = count > 0;
            return flag;
          });

        // #region Funzioni per la gestione delle viste

        $scope.isActiveView = function (viewUrl) {
          return viewUrl == $scope.service.views.defaultView.url;
        };

        $scope.changeView = function (view) {
          $scope.service.views.defaultView = view;
        };

        $scope.showDetails = function (item) {
          $scope.service.views.defaultView = $scope.service.views.listView[1];
          $scope.service.currentItem = item;
        };

        $scope.backToTable = function () {
          $scope.service.views.defaultView = $scope.service.views.listView[0];
          $scope.service.currentItem = null;
        };

        // #endregion

        $scope.exportTableToCSV = function () {
          var dataCSV = [];
          // Elimino i campi di angular (quelli che iniziano per $)
          for (var index in $scope.service.datasource) {
            var element = $scope.service.datasource[index];
            var current = {};
            for (var item in element) {
              if (item.indexOf('$') !== 0) {
                current[item] = element[item];
              }
            }
            dataCSV.push(current);
          }
          commonUtilities.downloadCSV(dataCSV, 'export-movimenti.csv');
        };

        $scope.init = (function () {
          if (
            (!$scope.hasItems() &&
              $scope.service.inputFormMovimenti.startDate === null) ||
            $scope.service.numeroRapporto !== $scope.numeroRapporto
          ) {
            $scope.service.views.defaultView = $scope.service.views.listView[0];
            $scope.service.currentItem = null;
            $scope.service.numeroRapporto = $scope.numeroRapporto;
          }
        })();
      };
      directiveImpl.$inject = ['$scope'];

      return {
        restrict: 'E',
        scope: {
          numeroRapporto: '=?numeroRapporto'
        },
        templateUrl:
          CONSTANTS.BASE_ROOT +
          'widgets/finDossierMovements/finDossierMovements.html',
        replace: false,
        controller: directiveImpl
      };
    }
  ]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finDossierMovements/finDossierMovementsDrct.js
 ** module id = 34
 ** module chunks = 1 2
 **/